
function v4Agendar(fn){
  
  if(!(window.matchMedia && matchMedia('(max-width: 860px)').matches)){ fn(); return; }
  var feito=false;
  function ir(){ if(feito) return; feito=true; removeEventListener('scroll',ir); fn(); }
  if(document.readyState==='complete'){ setTimeout(ir,300); }
  else { addEventListener('load', function(){ setTimeout(ir,300); }); }
  addEventListener('scroll', ir, {passive:true});
}

var V4BASE = "//trenchies.co/cdn/shop/t/6/assets/v4.css?v=11072059740555305331787785601".split('?')[0].replace(/v4\.css$/, '');
/* Trenchies V4 · approved page scripts + real Shopify cart */
;

(function(){
  var els=document.querySelectorAll('.badge');
  if('IntersectionObserver' in window){
    els.forEach(function(b){b.classList.add('reveal');});
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){var el=e.target;var i=[].indexOf.call(el.parentNode.children,el);el.style.transitionDelay=(i*90)+'ms';el.classList.add('in');io.unobserve(el);}
      });
    },{threshold:.15});
    els.forEach(function(b){io.observe(b);});
  }
})();

;

(function(){
  var sec=document.querySelector('.moments'); if(!sec) return;
  function go(){sec.classList.add('go');}
  function arm(){
    var r=sec.getBoundingClientRect();
    if(r.top<innerHeight*0.55){return;} 
    sec.classList.add('js-m');
    if('IntersectionObserver' in window){
      
      var fb=function(){
        if(sec.classList.contains('go')){removeEventListener('scroll',fb);return;}
        var rr=sec.getBoundingClientRect();
        if(rr.top<innerHeight*0.8&&rr.bottom>0){go();removeEventListener('scroll',fb);}
      };
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){go();io.disconnect();removeEventListener('scroll',fb);}});},{threshold:0,rootMargin:'0px 0px -20% 0px'});
      io.observe(sec);
      addEventListener('scroll',fb,{passive:true}); 
    } else { go(); }
  }
  if(document.readyState==='complete'){arm();} else {window.addEventListener('load',arm);}
})();

;


(function(){
  var card=document.getElementById('spincard'), cv=document.getElementById('spinc');
  if(!card||!cv||!cv.getContext) return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var N=61, imgs=[], loaded=0, cur=0, tgt=0, drawn=-1, ctx=cv.getContext('2d');
  function prog(){
    var r=card.getBoundingClientRect(), vh=window.innerHeight||1;
    var p=(vh-r.top)/(vh+r.height);
    p=(p-.18)/.64; 
    return p<0?0:(p>1?1:p);
  }
  function step(){
    tgt=prog()*(N-1);
    cur+=(tgt-cur)*.16;
    if(Math.abs(tgt-cur)<.02) cur=tgt;
    var f=Math.round(cur);
    if(f!==drawn&&imgs[f]&&imgs[f].complete){ctx.drawImage(imgs[f],0,0,900,900);drawn=f;card.setAttribute('data-f',f);}
    requestAnimationFrame(step);
  }
  function boot(){
    
    if(window.matchMedia && matchMedia('(max-width: 860px)').matches){
      var r=card.getBoundingClientRect();
      if(r.top < innerHeight && r.bottom > 0) return;
    }
    card.classList.add('on');
    cur=tgt=prog()*(N-1);
    step();
  }
  function precarregar(){
    for(var i=0;i<N;i++)(function(i){
      var im=new Image();
      im.onload=function(){if(++loaded===N)boot();};
      im.src=V4BASE+'v4-spin-f'+('00'+i).slice(-3)+'.webp';
      imgs[i]=im;
    })(i);
  }
  
  v4Agendar(precarregar);
})();

;


(function(){
  var w=document.getElementById('factflip'), b=document.getElementById('ffbtn');
  if(!w||!b) return;
  w.classList.add('js');
  var lb=b.querySelector('span');
  function t(){
    var on=w.classList.toggle('fl');
    b.setAttribute('aria-pressed',on?'true':'false');
    lb.textContent=on?'Flip back to the bag':'Flip to read the label';
  }
  b.addEventListener('click',function(e){e.stopPropagation();t();});
  w.querySelector('.ffin').addEventListener('click',t);
})();

;


(function(){
  var sec=document.querySelector('.stack.orbitf'), oc=document.getElementById('ocenter'), cv=document.getElementById('orbc');
  if(!sec||!oc||!cv||!cv.getContext) return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var A=0,B=36,imgs={},loaded=0,ready=false,triggered=false,played=false,ctx=cv.getContext('2d');
  function draw(f){ctx.drawImage(imgs[f],0,0,900,900);oc.setAttribute('data-f',f);}
  function play(){
    if(played||!ready)return; played=true;
    var t0=null;
    function fr(ts){
      if(t0===null)t0=ts;
      var t=(ts-t0)/2200; if(t>1)t=1;
      var e=t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2; /* easeInOutCubic */
      draw(A+Math.round(e*(B-A)));
      if(t<1)requestAnimationFrame(fr);
    }
    requestAnimationFrame(fr);
  }
  function onReady(){
    
    ready=true; oc.classList.add('on');
    if(triggered)play(); else draw(A);
  }
  function go(){sec.classList.add('go');triggered=true;play();}
  function arm(){
    var r=sec.getBoundingClientRect();
    if(r.top<innerHeight*0.55){return;} 
    sec.classList.add('js-o');
    function precarregarOrb(){
      for(var i=A;i<=B;i++)(function(i){
        var im=new Image();
        im.onload=function(){if(++loaded===B-A+1)onReady();};
        im.src=V4BASE+'v4-orb-f'+('00'+i).slice(-3)+'.webp';
        imgs[i]=im;
      })(i);
    }
    
    v4Agendar(precarregarOrb);
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){go();io.disconnect();}});},{threshold:.15});
      io.observe(sec);
      setTimeout(function(){if(!sec.classList.contains('go')){var rr=sec.getBoundingClientRect();if(rr.top<innerHeight&&rr.bottom>0)go();}},2600);
    } else { go(); }
  }
  if(document.readyState==='complete'){arm();} else {window.addEventListener('load',arm);}
})();

;

/* TIKTOK WALL: marquee pausa no hover (CSS); clique abre o clipe no lightbox (video so carrega no clique). */
(function(){
  var lb=document.getElementById('ttlb'), vid=document.getElementById('ttlbv'), x=document.getElementById('ttlbx');
  if(!lb||!vid) return;
  var marq=document.querySelector('.ttwall .marq');
  function close(){lb.classList.remove('on');vid.pause();vid.removeAttribute('src');vid.load();if(marq)marq.classList.remove('hold');}
  function open(src){lb.classList.add('on');vid.src=src;var p=vid.play();if(p&&p.catch)p.catch(function(){});if(marq)marq.classList.add('hold');}
  [].slice.call(document.querySelectorAll('.ttcard[data-v]')).forEach(function(c){
    c.addEventListener('click',function(){open(c.getAttribute('data-v'));});
    c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open(c.getAttribute('data-v'));}});
  });
  if(x)x.addEventListener('click',close);
  lb.addEventListener('click',function(e){if(e.target===lb)close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&lb.classList.contains('on'))close();});
})();

;

(function(){
  // Gallery: clickable thumbs + arrows
  var main=document.getElementById('gmain-img');
  var thumbs=[].slice.call(document.querySelectorAll('.thumbs .thumb'));
  /* use the thumbs' own versioned URLs (?v= digest from Liquid) so the CDN never serves a stale unversioned cache entry */
  var srcs=thumbs.map(function(t){var im=t.querySelector('img');return im?(im.getAttribute('data-full')||im.currentSrc||im.src):null;});
  if(main&&srcs.length&&!srcs[0]) srcs[0]=main.src;
  var gi=0;
  var gtag=document.querySelector('.gmain .tag');
  function show(n){gi=(n+srcs.length)%srcs.length; if(main&&srcs[gi]) main.src=srcs[gi]; if(gtag) gtag.style.display=(gi===0)?'':'none'; thumbs.forEach(function(t,k){t.classList.toggle('on',k===gi);});}
  thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k);});});
  var prev=document.querySelector('.arrow.prev'), next=document.querySelector('.arrow.next');
  if(prev) prev.addEventListener('click',function(){show(gi-1);});
  if(next) next.addEventListener('click',function(){show(gi+1);});
  // tap na foto avanca + swipe (mobile)
  var gwrap=document.querySelector('.gmain'), swiped=false;
  if(gwrap&&main){
    main.style.cursor='pointer';
    main.addEventListener('click',function(){if(swiped)return;show(gi+1);});
    var tx=0,ty=0;
    gwrap.addEventListener('touchstart',function(e){tx=e.changedTouches[0].clientX;ty=e.changedTouches[0].clientY;},{passive:true});
    gwrap.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-tx,dy=e.changedTouches[0].clientY-ty;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){swiped=true;show(gi+(dx<0?1:-1));setTimeout(function(){swiped=false;},400);}},{passive:true});
  }

  // Buy box: one-time / subscribe toggle + size selection
  var modeBtns=[].slice.call(document.querySelectorAll('.pt'));
  var opts=[].slice.call(document.querySelectorAll('.opt'));
  var subbox=document.getElementById('subbox');
  var subperks=document.getElementById('subperks');
  var mode='once';
  function render(){
    modeBtns.forEach(function(b){b.classList.toggle('on',b.dataset.mode===mode);});
    opts.forEach(function(o){
      var now=o.querySelector('.now'), was=o.querySelector('.was');
      if(now && now.dataset[mode]!==undefined) now.textContent=now.dataset[mode];
      if(was) was.textContent=was.dataset[mode]||'';
      var pp=o.querySelector('.ppp');
      if(pp) pp.textContent=pp.dataset[mode]||'';
    });
    if(subbox) subbox.style.display = (mode==='sub') ? 'block' : 'none';
    if(subperks) subperks.style.display = (mode==='sub') ? 'flex' : 'none';
    updateSv();
  }
  // badge do toggle reage ao tamanho selecionado (25.19 vs 27.99 = 10% · 40.50 vs 55.98 = 28%)
  var sv=document.getElementById('svbadge');
  var perkship=document.getElementById('perkship');
  var perkpct=document.getElementById('perkpct');
  function updateSv(){
    var on=document.querySelector('.opt.on');
    var size=on?on.dataset.size:'2';
    var pct=(size==='1')?'10% off':'28% off'; // real behavior: the automatic discount stacks with the 10% plan -> 2 bags sub = $40.50 (28% effective)
    if(sv) sv.textContent=pct;
    if(perkpct) perkpct.textContent=pct;
    if(perkship) perkship.style.display=(size==='2')?'inline-flex':'none';
  }
  modeBtns.forEach(function(b){b.addEventListener('click',function(){mode=b.dataset.mode;render();});});
  opts.forEach(function(o){o.addEventListener('click',function(){opts.forEach(function(x){x.classList.remove('on');});o.classList.add('on');updateSv();});});
  render();
  
  var qBags=new URLSearchParams(location.search).get('bags');
  if(qBags){var qo=opts.filter(function(o){return o.dataset.size===qBags;})[0];
    if(qo){opts.forEach(function(x){x.classList.remove('on');});qo.classList.add('on');updateSv();}} var qMode=new URLSearchParams(location.search).get('mode'); if(qMode){ for(var qi=0; qi<modeBtns.length; qi++){ if(modeBtns[qi].dataset.mode===qMode){ modeBtns[qi].click(); break; } } }

  // helps section: subtle staggered reveal on scroll
  var hs=[].slice.call(document.querySelectorAll('.helpc'));
  if('IntersectionObserver' in window){
    hs.forEach(function(h){h.classList.add('reveal');});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var el=e.target;var i=[].indexOf.call(el.parentNode.children,el);el.style.transitionDelay=(i*110)+'ms';el.classList.add('in');io.unobserve(el);}});},{threshold:.15});
    hs.forEach(function(h){io.observe(h);});
  }

  // reviews: reveal all on "see more"
  var seemore=document.getElementById('seemore');
  if(seemore){seemore.addEventListener('click',function(){var hid=[].slice.call(document.querySelectorAll('.rcard.rhidden'));hid.slice(0,12).forEach(function(c){c.classList.remove('rhidden');});if(!document.querySelector('.rcard.rhidden')){seemore.parentNode.style.display='none';}});}
})();
;

  (function(){
    var sec=document.querySelector('.reasons'); if(!sec) return;
    function go(){sec.classList.add('go');}
    function arm(){
      
      var r=sec.getBoundingClientRect();
      if(r.top<innerHeight&&r.bottom>0){return;} 
      sec.classList.add('js-r');
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){go();io.disconnect();}});},{threshold:.1});
        io.observe(sec);
        setTimeout(function(){if(!sec.classList.contains('go')){var rr=sec.getBoundingClientRect();if(rr.top<innerHeight&&rr.bottom>0)go();}},2600);
      } else { go(); }
    }
    if(document.readyState==='complete'){arm();} else {window.addEventListener('load',arm);}
  })();
;

(function(){
  var dim=document.getElementById('cdim'), dr=document.getElementById('cdrawer');
  if(!dim || !dr) return;
  var PLAN_MONTHLY=null;
  (function(){ var r=document.querySelector('.tv4-product');
    if(r){ try{ var p=JSON.parse((r.dataset.plans||'{}').replace(/,\s*}/,'}')); PLAN_MONTHLY=p['1']||null; }catch(e){} }
  })();
  function money(c){ return '$' + (c/100).toFixed(2); }
  var lockY=0; function openD(){ cdFetchRender().then(function(){ lockY=window.scrollY||window.pageYOffset||0; dim.classList.add('on'); dr.classList.add('on'); document.body.style.overflow='hidden'; document.body.style.position='fixed'; document.body.style.top=(-lockY)+'px'; document.body.style.width='100%'; }); }
  function closeD(){ dim.classList.remove('on'); dr.classList.remove('on'); document.body.style.overflow=''; document.body.style.position=''; document.body.style.top=''; document.body.style.width=''; window.scrollTo(0,lockY); }
  function render(cart){
    var items=document.getElementById('cd-items');
    var empty=document.getElementById('cd-empty');
    var foot=document.getElementById('cd-foot');
    var shipw=document.getElementById('cd-shipwrap');
    if(!cart || typeof cart.item_count==='undefined'){ return; }
    document.getElementById('cd-count').textContent='('+cart.item_count+')';
    if(cart.item_count===0){
      empty.style.display='flex'; items.style.display='none'; foot.style.display='none'; shipw.style.display='none';
      return;
    }
    empty.style.display='none'; items.style.display=''; foot.style.display=''; shipw.style.display='';
    var html='';
    cart.items.forEach(function(it, idx){
      var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : null;
      var q = it.quantity;
      var lineTitle = (q>=2 ? q+' Bags' : '1 Bag') + ' · Trenchies';
      var sub = plan
        ? ('Subscribe & Save · renews at ' + money(it.final_line_price) + (plan.indexOf('2')>-1 ? ' every 2 mo' : '/mo'))
        : 'One-time purchase';
      var img = V4BASE + (q>=2 ? 'v4-pack-2.png' : 'v4-pack-1.png');
      var save = (2799 * q) - it.final_line_price;
      html += '<div class="cd-item">'
        + '<img src="'+img+'" alt="Trenchies">'
        + '<div class="b"><div class="t">'+lineTitle+'</div>'
        + '<div class="m">'+sub+'</div>'
        + '<div class="cd-qty"><button data-l="'+(idx+1)+'" data-q="'+(q-1)+'" aria-label="Less">&minus;</button><span>'+q+'</span><button data-l="'+(idx+1)+'" data-q="'+(q+1)+'" aria-label="More">+</button></div>'
        + '<button class="cd-xrm" data-l="'+(idx+1)+'" data-q="0" type="button">Remove</button></div>'
        + '<div class="cd-pricecol"><span class="cd-item pr" style="border:0;padding:0">'+money(it.final_line_price)+'</span>'
        + (save>0 ? '<span class="was">'+money(2799*q)+'</span><span class="cd-isave">You save '+money(save)+'</span>' : '')
        + '</div></div>';
    });
    
    var up='';
    var onceIdx=-1, onceItem=null, temSub=false, subIdx=-1, subItem=null;
    cart.items.forEach(function(it, idx){
      if(!it.selling_plan_allocation && onceIdx<0){ onceIdx=idx; onceItem=it; }
      if(it.selling_plan_allocation){ temSub=true; if(subIdx<0){ subIdx=idx; subItem=it; } }
    });
    function tier(lineTitle, badge, best, price, struck, attrs){
      return '<div class="cd-upc tier">'+(best?'<span class="flag">★ Best value</span>':'')
        + '<img src="'+V4BASE+(lineTitle.indexOf('2')>-1?'v4-pack-2.png':'v4-pack-1.png')+'" alt="Add bags"><div class="b">'
        + '<div class="t">'+lineTitle+' '+(badge?'<span class="pct">'+badge+'</span>':'')+'</div>'
        + '<div class="m">Only +'+money(price)+(struck?' <s>'+money(struck)+'</s>':'')+'</div></div>'
        + '<button '+attrs+' type="button">+ Add</button></div>';
    }
    function pctOf(delta, cheio){ return Math.round((1 - delta/cheio) * 100) + '% off'; }
    
    var MAXBAGS = 3;
    if(onceItem){
      var q0=onceItem.quantity;
      var d1 = q0>=2 ? 2250 : 1701;
      var d2 = q0>=2 ? 4500 : 3951;
      var t1='';
      if(q0+1<=MAXBAGS) t1 += tier('Add 1 more bag', pctOf(d1,2799)+' it', q0+2>MAXBAGS, d1, 2799, 'data-up="qty" data-l="'+(onceIdx+1)+'" data-q="'+(q0+1)+'"');
      if(q0+2<=MAXBAGS) t1 += tier('Add 2 more bags', pctOf(d2,5598)+' them', true, d2, 5598, 'data-up="qty" data-l="'+(onceIdx+1)+'" data-q="'+(q0+2)+'"');
      if(t1) up += '<div class="sublbl">The more bags you add, the less each one costs.</div>' + t1;
      if(q0===1 && !temSub && PLAN_MONTHLY){
        up += '<div class="cd-upc"><img src="'+V4BASE+'v4-pack-1.png" alt="Subscribe"><div class="b">'
           + '<div class="t">Switch to Subscribe &amp; Save</div>'
           + '<div class="m">10% off every order · skip, pause, or cancel anytime</div></div>'
           + '<button data-up="sub" data-l="'+(onceIdx+1)+'" data-q="'+q0+'" type="button">Switch</button></div>';
      }
    } else if(subItem){
      /* Subscription-only cart: grow the plan line itself, same as the one-time branch grows its own line. Adding a separate one-time line gets no discount (measured in the real cart: Kaching counts per line, not the whole cart). */
      var qs=subItem.quantity;
      /* subscription line price: Kaching charges $22.50/unit from 2 units on the line, and the selling plan takes 10% on top. Matches measured: 1=$25.19, 2=$40.50. */
      var subPrice = function(n){ return Math.round((n>=2 ? 2250 : 2799) * n * 0.9); };
      var ds1 = subPrice(qs+1) - subItem.final_line_price;
      var ds2 = subPrice(qs+2) - subItem.final_line_price;
      var t2='';
      if(qs+1<=MAXBAGS) t2 += tier('Add 1 bag to every delivery', pctOf(ds1,2799)+' it', qs+2>MAXBAGS, ds1, 2799,
                 'data-up="qty" data-l="'+(subIdx+1)+'" data-q="'+(qs+1)+'"');
      if(qs+2<=MAXBAGS) t2 += tier('Add 2 bags to every delivery', pctOf(ds2,5598)+' them', true, ds2, 5598,
                 'data-up="qty" data-l="'+(subIdx+1)+'" data-q="'+(qs+2)+'"');
      if(t2){
        up += '<div class="sublbl" style="font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#0E1B33;font-size:11.5px">Complete your supply</div>';
        up += '<div class="sublbl">Ships with this order and every one after. Skip or pause anytime.</div>' + t2;
      }
    }
    if(up){ html += '<div class="cd-up">'+up+'</div>'; }
    items.innerHTML=html;
    // ===== bindings =====
    var changing=false; function doChange(body){ if(changing) return; changing=true; fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();}).then(function(c){changing=false; render(c);}).catch(function(){changing=false;}); }
    var qbtns=items.querySelectorAll('[data-l]:not([data-up])');
    for(var i2=0;i2<qbtns.length;i2++){
      qbtns[i2].addEventListener('click', function(){
        doChange({line:parseInt(this.dataset.l,10), quantity:Math.max(0,parseInt(this.dataset.q,10))});
      });
    }
    var ubtns=items.querySelectorAll('[data-up]');
    for(var u=0;u<ubtns.length;u++){
      ubtns[u].addEventListener('click', function(){
        var kind=this.dataset.up;
        if(kind==='addonce'){
          var fd=new FormData();
          fd.append('id', (document.querySelector('.tv4-product')||{dataset:{}}).dataset.variant || '45310467113148');
          fd.append('quantity', parseInt(this.dataset.n,10)||1);
          fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
            .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
            .then(function(r){return r.json();}).then(render).catch(function(){});
          return;
        }
        var body={line:parseInt(this.dataset.l,10), quantity:Math.max(0,parseInt(this.dataset.q,10))};
        if(kind==='sub' && PLAN_MONTHLY){ body.selling_plan=PLAN_MONTHLY; }
        doChange(body);
      });
    }
    // ===== totais =====
    var totalBags=0; cart.items.forEach(function(it){ totalBags += it.quantity; });
    var descTotal=(2799*totalBags)-cart.total_price;
    var saveRow=document.getElementById('cd-save');
    if(saveRow){ if(descTotal>0){ saveRow.style.display='flex'; document.getElementById('cd-savev').textContent='−'+money(descTotal); } else { saveRow.style.display='none'; } }
    document.getElementById('cd-sub').textContent=money(cart.total_price);
    document.getElementById('cd-cta').textContent='Secure Checkout · '+money(cart.total_price);
    var SHIP=3500;
    var t=document.getElementById('cd-shipt'), bar=document.getElementById('cd-bar');
    if(cart.total_price>=SHIP){ t.innerHTML="Congrats! You've unlocked <b>FREE SHIPPING</b> ✓"; bar.style.width='100%'; }
    else{ t.innerHTML="You're <b>"+money(SHIP-cart.total_price)+"</b> away from free shipping"; bar.style.width=Math.min(100, cart.total_price/SHIP*100)+'%'; }
  }
  function cdFetchRender(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render).catch(function(){});
  }
  dim.addEventListener('click', closeD);
  document.getElementById('cd-x').addEventListener('click', closeD);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeD(); });
  var ecta=document.getElementById('cd-empty-cta');
  if(ecta){ ecta.addEventListener('click', function(){ closeD(); var b=document.getElementById('buy'); if(b) b.scrollIntoView({behavior:'smooth'}); else window.location.href='/products/candy#buy'; }); }
  window.__v4CartOpen = openD;
})();
;
(function(){
  var root=document.querySelector('.tv4-product');
  var navC=document.getElementById('navCart');
  if(navC){ navC.addEventListener('click', function(e){ e.preventDefault(); if(window.__v4CartOpen) window.__v4CartOpen(); else window.location.href='/cart'; }); }
  if(!root) return;
  var VARIANT=root.dataset.variant;
  var PLANS={};
  try{ PLANS=JSON.parse((root.dataset.plans||'{}').replace(/,\s*}/,'}')); }catch(e){}
  function addToCart(){
    var m=document.querySelector('.pt.on'); var o=document.querySelector('.opt.on');
    var mode=m?m.dataset.mode:'once';
    var size=o?parseInt(o.dataset.size,10)||1:1;
    var fd=new FormData();
    fd.append('id', VARIANT);
    fd.append('quantity', size);
    if(mode==='sub'){
      var freq=document.getElementById('freq');
      var key=freq?freq.value:'1';
      var pid=PLANS[key]; if(!pid){ for(var pk in PLANS){ pid=PLANS[pk]; break; } } if(!pid){ var ob=document.querySelector('.pt[data-mode="once"]'); if(ob) ob.click(); return; } fd.append('selling_plan', pid);
    }
    var btn=document.querySelector('.buy .btn.add');
    if(btn){ btn.disabled=true; btn.style.opacity='.6'; }
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ if(window.__v4CartOpen) window.__v4CartOpen(); else window.location.href='/cart'; })
      .catch(function(){ window.location.href='/cart'; })
      .finally(function(){ if(btn){ btn.disabled=false; btn.style.opacity=''; } });
  }
  var addBtn=document.querySelector('.buy .btn.add');
  if(addBtn){ addBtn.addEventListener('click', function(e){ e.preventDefault(); addToCart(); }); }
})();
